import React from 'react';
import Sidebar from '../Components/Sidebar';
import { Link } from 'react-router-dom';
import { Dropdown, Carousel, Button } from 'react-bootstrap';
import slider2 from '../Components/Image/slider2.jpg'
import slider3 from '../Components/Image/slider3.jpg'
import slider4 from '../Components/Image/slider4.jpg'
import carausel5 from '../Components/Image/carousel5.jpeg'
import SMSGroup from '../Components/Image/SMSGroup.png'
// import carausel3 from '../Components/Image/Carousel3'
import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, getPOSearch, postPOLineItem, inspectionDashboard, getSupplierPOs } from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'
import authInstance from '../Classes/AuthHandler';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AuthHandlerInstance from '../Classes/AuthHandler'
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'

class DispatchDashboard extends React.Component {

    componentDidMount() {
        NotificationManager.info('Info message');
        const form = {
            //  POId: req.params.id,
            PurchaseOrderLineId: 'req.params.lineid',
            QATemplateName: 'req.body.template',
            TemplateId: 'req.body.TemplateId',
            SeqNo: 'req.body.SeqNo',
            StageId: 'req.body.StageId'

        }
        // this.props.getQATemplates()
        // this.props.getPODetails(1)
        // this.props.getDepartmentSearch()
        // // this.props.postPOLineItem(form)
        // this.props.inspectionDashboard()
        // this.props.getSupplierPOs()
    }
    render() {
        var roles = AuthHandlerInstance.getRoles()
        var groups = authInstance.getGroups()
        const { qaTemplate } = this.props.qaTemplate
        console.log(qaTemplate)
        console.log(this.props.poDetails)
        var roles = authInstance.getRoles()
        console.log("roles=", roles, "groups=", groups)

        console.log(roles)
        return (


            <div className="container-fluid" style={{ padding: 0 }}>

                {/* <div className="row"> */}
                {/* <Sidebar/> */}


                {/* <div className='red col-10 containerfluid'>
asfsafsafasfsafsafasfsafsafasfsafsafasfsafsafasfsafsaf
            </div> */}

                {/* <div className=" container-fluid "> */}

                <Carousel className="container-fluid" >
                    <Carousel.Item>
                        <img src={slider4} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={slider2} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img src={slider3} style={{ width: "100%", height: 400, objectFit: "cover" }} />
                        <div className="container-fluid mr-6">
                            <span className="sms-content-slider-header">HIGHLIGHT PROJECTS</span>
                            <span className="sms-content-slider-subheader">SMS Group</span>
                        </div>
                    </Carousel.Item>


                </Carousel>
                {/* <div className="row pt-4">
                    
                       <button href="/Supplier" className="btn1 btn-sms1 ml-2">QA PLANNING </button>
                       <button href="#" className="btn1 btn-sms ml-6 dashboard-btn"> PLAN INSPECTION</button>
                       <button href="#" className="btn1 btn-sms dashboard-btn"> ALLOCATE INSPECTOR</button>
                      
                     </div> */}

                <div className="row pt-4 pb-4">
                    {/*---------------------------------- TPM Role--------------------- */}
                    {roles[12] == true && groups[19] == true ?
                        <div className="row flex-sm-fill mr-4 ml-2">
                            <div className="col-sm-4">
                                <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                    <div className="card card-fluid">
                                        <div className="card-body text-center">
                                            <div className="avatar-parent-child">
                                                <a className="avatar avatar-lg rounded-circle">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                </a>
                                                <span className="avatar-child avatar-badge bg-success" />
                                            </div>
                                            <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-sm-4">
                                <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                    <div className="card card-fluid">
                                        <div className="card-body text-center">
                                            <div className="avatar-parent-child">
                                                <a className="avatar avatar-lg rounded-circle">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                </a>
                                                <span className="avatar-child avatar-badge bg-success" />
                                            </div>
                                            <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-sm-4">
                                <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                    <div className="card card-fluid">
                                        <div className="card-body text-center">
                                            <div className="avatar-parent-child">
                                                <a className="avatar avatar-lg rounded-circle">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                </a>
                                                <span className="avatar-child avatar-badge bg-success" />
                                            </div>
                                            <h5 className="h6 mt-4 mb-0">GRN</h5>

                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                        </div>
                                    </div>
                                </a>
                            </div>

                            <div className="col-sm-4 mt-3">
                                <a href="DispatchAddTemplate" className="avatar avatar-lg rounded-circle" >

                                    <div className="card card-fluid">
                                        <div className="card-body text-center">
                                            <div className="avatar-parent-child">
                                                <a className="avatar avatar-lg rounded-circle">
                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                </a>
                                                <span className="avatar-child avatar-badge bg-success" />
                                            </div>
                                            <h5 className="h6 mt-4 mb-0">Dispatch Template</h5>

                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>


                        :
                        // ---------------------Supplier------------------------------------

                        roles[5] == true && groups[6] == true ?
                            <div className="row flex-sm-fill mr-4 ml-2">
                                <div className="col-sm-4">
                                    <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                        <div className="card card-fluid">
                                            <div className="card-body text-center">
                                                <div className="avatar-parent-child">
                                                    <a className="avatar avatar-lg rounded-circle">
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                    </a>
                                                    <span className="avatar-child avatar-badge bg-success" />
                                                </div>
                                                <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className="col-sm-4">
                                    <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                        <div className="card card-fluid">
                                            <div className="card-body text-center">
                                                <div className="avatar-parent-child">
                                                    <a className="avatar avatar-lg rounded-circle">
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                    </a>
                                                    <span className="avatar-child avatar-badge bg-success" />
                                                </div>
                                                <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className="col-sm-4">
                                    <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                        <div className="card card-fluid">
                                            <div className="card-body text-center">
                                                <div className="avatar-parent-child">
                                                    <a className="avatar avatar-lg rounded-circle">
                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                    </a>
                                                    <span className="avatar-child avatar-badge bg-success" />
                                                </div>
                                                <h5 className="h6 mt-4 mb-0">GRN</h5>

                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            // ---------------------Supplier end------------------------------------
                            :
                            // -----------------------QA Planner-------------------
                            roles[6] == true && groups[4] == true ?

                                <div className="row flex-sm-fill mr-4 ml-2">
                                    <div className="col-sm-4">
                                        <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                            <div className="card card-fluid">
                                                <div className="card-body text-center">
                                                    <div className="avatar-parent-child">
                                                        <a className="avatar avatar-lg rounded-circle">
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                        </a>
                                                        <span className="avatar-child avatar-badge bg-success" />
                                                    </div>
                                                    <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="col-sm-4">
                                        <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                            <div className="card card-fluid">
                                                <div className="card-body text-center">
                                                    <div className="avatar-parent-child">
                                                        <a className="avatar avatar-lg rounded-circle">
                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                        </a>
                                                        <span className="avatar-child avatar-badge bg-success" />
                                                    </div>
                                                    <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                </div>
                                            </div>
                                        </a>
                                    </div>


                                </div>
                                :
                                // -----------------------LOGISTICS TEAM-------------------
                                roles[13] == true && groups[20] == true ?

                                    <div className="row flex-sm-fill mr-4 ml-2">

                                        <div className="col-sm-4">
                                            <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                                <div className="card card-fluid">
                                                    <div className="card-body text-center">
                                                        <div className="avatar-parent-child">
                                                            <a className="avatar avatar-lg rounded-circle">
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                            </a>
                                                            <span className="avatar-child avatar-badge bg-success" />
                                                        </div>
                                                        <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="col-sm-4">
                                            <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                                <div className="card card-fluid">
                                                    <div className="card-body text-center">
                                                        <div className="avatar-parent-child">
                                                            <a className="avatar avatar-lg rounded-circle">
                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                            </a>
                                                            <span className="avatar-child avatar-badge bg-success" />
                                                        </div>
                                                        <h5 className="h6 mt-4 mb-0">Dispatch Material</h5>

                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                    </div>
                                                </div>
                                            </a>
                                        </div>


                                    </div>

                                    // -----------------------QA Planner-------------------
                                    :
                                    // -----------------------Commercial Team-------------------
                                    roles[16] == true && groups[23] == true ?

                                        <div className="row flex-sm-fill mr-4 ml-2">
                                            <div className="col-sm-4">
                                                <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                                    <div className="card card-fluid">
                                                        <div className="card-body text-center">
                                                            <div className="avatar-parent-child">
                                                                <a className="avatar avatar-lg rounded-circle">
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                                </a>
                                                                <span className="avatar-child avatar-badge bg-success" />
                                                            </div>
                                                            <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-sm-4">
                                                <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                                    <div className="card card-fluid">
                                                        <div className="card-body text-center">
                                                            <div className="avatar-parent-child">
                                                                <a className="avatar avatar-lg rounded-circle">
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                                </a>
                                                                <span className="avatar-child avatar-badge bg-success" />
                                                            </div>
                                                            <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>
                                            <div className="col-sm-4">
                                                <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                                    <div className="card card-fluid">
                                                        <div className="card-body text-center">
                                                            <div className="avatar-parent-child">
                                                                <a className="avatar avatar-lg rounded-circle">
                                                                    <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                                </a>
                                                                <span className="avatar-child avatar-badge bg-success" />
                                                            </div>
                                                            <h5 className="h6 mt-4 mb-0">GRN</h5>

                                                            {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                        </div>
                                                    </div>
                                                </a>
                                            </div>


                                        </div>

                                        // -----------------------Commercial Team-------------------
                                        :

                                        // -----------------------Import Export Team-------------------
                                        roles[14] == true && groups[21] == true ?

                                            <div className="row flex-sm-fill mr-4 ml-2">
                                                <div className="col-sm-4">
                                                    <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="col-sm-4">
                                                    <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                                <div className="col-sm-4">
                                                    <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                                        <div className="card card-fluid">
                                                            <div className="card-body text-center">
                                                                <div className="avatar-parent-child">
                                                                    <a className="avatar avatar-lg rounded-circle">
                                                                        <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                                    </a>
                                                                    <span className="avatar-child avatar-badge bg-success" />
                                                                </div>
                                                                <h5 className="h6 mt-4 mb-0">GRN</h5>

                                                                {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>


                                            </div>

                                            // -----------------------Import Export Team-------------------

                                            :

                                            // -----------------------Purchase Team-------------------
                                            roles[15] == true && groups[22] == true ?
                                                <div className="row flex-sm-fill mr-4 ml-2">
                                                    <div className="col-sm-4">
                                                        <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                                            <div className="card card-fluid">
                                                                <div className="card-body text-center">
                                                                    <div className="avatar-parent-child">
                                                                        <a className="avatar avatar-lg rounded-circle">
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                                        </a>
                                                                        <span className="avatar-child avatar-badge bg-success" />
                                                                    </div>
                                                                    <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>
                                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                                            <div className="card card-fluid">
                                                                <div className="card-body text-center">
                                                                    <div className="avatar-parent-child">
                                                                        <a className="avatar avatar-lg rounded-circle">
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                                        </a>
                                                                        <span className="avatar-child avatar-badge bg-success" />
                                                                    </div>
                                                                    <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                                            <div className="card card-fluid">
                                                                <div className="card-body text-center">
                                                                    <div className="avatar-parent-child">
                                                                        <a className="avatar avatar-lg rounded-circle">
                                                                            <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                                        </a>
                                                                        <span className="avatar-child avatar-badge bg-success" />
                                                                    </div>
                                                                    <h5 className="h6 mt-4 mb-0">GRN</h5>

                                                                    {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                                :
                                                // -----------------------Finance Team-------------------
                                                roles[9] == true && groups[10] == true ?
                                                    <div className="row flex-sm-fill mr-4 ml-2">
                                                        <div className="col-sm-4">
                                                            <a href="DispatchHome" className="avatar avatar-lg rounded-circle" >

                                                                <div className="card card-fluid">
                                                                    <div className="card-body text-center">
                                                                        <div className="avatar-parent-child">
                                                                            <a className="avatar avatar-lg rounded-circle">
                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"clipboard-check"} color={"black"} title="Accept" size="4x" />
                                                                            </a>
                                                                            <span className="avatar-child avatar-badge bg-success" />
                                                                        </div>
                                                                        <h5 className="h6 mt-4 mb-0">Inspection Clearence</h5>

                                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <a href="DispatchMaterialPO" className="avatar avatar-lg rounded-circle" >

                                                                <div className="card card-fluid">
                                                                    <div className="card-body text-center">
                                                                        <div className="avatar-parent-child">
                                                                            <a className="avatar avatar-lg rounded-circle">
                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"truck-moving"} color={"black"} title="Accept" size="4x" />
                                                                            </a>
                                                                            <span className="avatar-child avatar-badge bg-success" />
                                                                        </div>
                                                                        <h5 className="h6 mt-4 mb-0">Dispatch material</h5>

                                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>

                                                        <div className="col-sm-4">
                                                            <a href="GRNPO" className="avatar avatar-lg rounded-circle" >

                                                                <div className="card card-fluid">
                                                                    <div className="card-body text-center">
                                                                        <div className="avatar-parent-child">
                                                                            <a className="avatar avatar-lg rounded-circle">
                                                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                                                            </a>
                                                                            <span className="avatar-child avatar-badge bg-success" />
                                                                        </div>
                                                                        <h5 className="h6 mt-4 mb-0">GRN</h5>

                                                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}

                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>




                                                    </div>
                                                    /* // -----------------------Finance Team------------------- */
                                                    :




                                                    <div className="row flex-sm-fill mr-4 ml-2">







                                                    </div>
                    }
                    {roles[12] || roles[19] ?
                        <div className="col-sm-4">
                            <a href={roles[12] ? "DispatchClearanceTable" : roles[19] ? "DispatchIssueDC" : null} className="avatar avatar-lg rounded-circle" >

                                <div className="card card-fluid">
                                    <div className="card-body text-center">
                                        <div className="avatar-parent-child">
                                            <a className="avatar avatar-lg rounded-circle">
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                            </a>
                                            <span className="avatar-child avatar-badge bg-success" />
                                        </div>
                                        <h5 className="h6 mt-4 mb-0">Dispatch Clearance</h5>

                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}
                                    </div>
                                </div>
                            </a>
                        </div>
                        : null}

                    {roles[5] ?
                        <div className="col-sm-4">
                            <a href="DispatchVendorDocumentSubmission" className="avatar avatar-lg rounded-circle" >

                                <div className="card card-fluid">
                                    <div className="card-body text-center">
                                        <div className="avatar-parent-child">
                                            <a className="avatar avatar-lg rounded-circle">
                                                <FontAwesomeIcon className="align-middle mt-2 pr-2" style={{ marginLeft: "10px" }} icon={"people-carry"} color={"black"} title="Accept" size="4x" />
                                            </a>
                                            <span className="avatar-child avatar-badge bg-success" />
                                        </div>
                                        <h5 className="h6 mt-4 mb-0">Dispatch Clearance</h5>

                                        {/* <a href="#" className="d-block text-sm text-muted mb-3">@john.sullivan</a> */}
                                    </div>
                                </div>
                            </a>
                        </div> : null}

                </div>


            </div>
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, inspectionDashboard, getSupplierPOs })(DispatchDashboard)
